import { ColumnProps } from 'primereact/column';

const columns: ColumnProps[] = [
  {
    header: 'Invoice',
    field: 'clover_invoice',
    sortable: true,
  },
  {
    header: 'Country Of Company Invoiced',
    field: 'country',
    sortable: true,
  },
  {
    header: 'Company',
    field: 'company',
    sortable: true,
  },
  {
    header: 'Invoice Date',
    field: 'created',
    sortable: true,
  },
  {
    header: 'Invoice Amount',
    field: 'total',
    sortable: true,
  },
  {
    header: 'Currency',
    field: 'currency',
    sortable: true,
  },
  {
    header: 'NB. Of People In Invoice',
    field: 'personcount',
    sortable: true,
  },
  {
    header: 'Exception Description',
    field: 'clover_exceptiondescription',
    sortable: true,
  },
  {
    header: 'Status Description',
    field: 'azadea_statusdescription',
    sortable: true,
  },

  {
    header: 'Rejection Description',
    field: 'azadea_hrms_rejectiondescription',
    sortable: true,
  },

  {
    header: 'More Details',
    field: 'more_details',
  },
  {
    header: 'Details in List 6',
    field: 'list_6_details',
  },
];

export default columns;
